import { Injectable, inject } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { applicationStringFromApplicationType, productStringFromApplicationType } from "src/app/views-interfaces/ApplicationType.enum";
import { AuthService } from "../auth/auth.service";
import { DashboardsService } from "../dashboards-service/dashboards.service";
import { FirmsService } from "../firms-service/firms.service";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { SpanAttributeValue } from "@sentry/core";

@Injectable({
    providedIn: "root",
})
export class SentryService {
    private authService = inject(AuthService);
    private firmsService = inject(FirmsService);
    private iframeMessagesService = inject(IframeMessagesService);
    dashboardsService = inject(DashboardsService);

    constructor() {}

    trace(name: string, op: string, f: () => Promise<{ key: string; value: SpanAttributeValue | undefined }[]>) {
        Sentry.startSpanManual({ name, op }, async (span) => {
            const additionalInfo = await f();
            const currentDashboard = await this.dashboardsService.getCurrentDashboard();
            const firm = await this.firmsService.getFirmById(this.authService.currentUser.firm_id);
            span?.setAttribute("Site URL", this.iframeMessagesService?.messagesOrigin);
            span?.setAttribute("Application", applicationStringFromApplicationType(currentDashboard.ApplicationType));
            span?.setAttribute("Product", productStringFromApplicationType(currentDashboard.ApplicationType));
            span?.setAttribute("Firm name", firm.Name);
            span?.setAttribute("Dashboad title", currentDashboard.Title);
            span?.setAttribute("Tax year", currentDashboard.TaxYear);
            for (const item of additionalInfo) {
                span?.setAttribute(item.key, item.value);
            }
            span?.end();
        });
    }
}
